import React from 'react';
import './view_field.css';

export const ViewField = ({ title, icon, children, className }) => {
  return (
    <div className={className || "view-field"}>
      { title && <div className="view-field-title">{title}</div> }
      <div className="view-field-content">
        { icon && <div className="view-field-icon">{icon}</div> }
        <div className="view-field-value">{children}</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/view_field/view_field.js